import { createSlice } from "@reduxjs/toolkit";
import {
  createSection17OrderRequestsAction,
  updateSection17OrderRequestsAction,
  getSection17OrderRequestsByCaseIDAction,
  deleteSection17OrderRequestsAction,
} from "../../actions/Sec17OrderRequests/sec17OrderRequestsAction";

const initialState = {
  OrderRequests: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const sec17OrderRequestsSlice = createSlice({
  name: "sec17OrderRequests",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
      state.OrderRequests = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSection17OrderRequestsByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getSection17OrderRequestsByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.OrderRequests = action.payload.Section17OrderRequests || [];
        },
      )
      .addCase(
        getSection17OrderRequestsByCaseIDAction.rejected,
        (state, action) => {
          state.loading = false;
          state.OrderRequests = action.payload;
        },
      );
    builder
      .addCase(createSection17OrderRequestsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createSection17OrderRequestsAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage =
            "Section - 17 Order Requests created successfully";
          state.OrderRequests.push(action.payload.data);
        },
      )
      .addCase(createSection17OrderRequestsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateSection17OrderRequestsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updateSection17OrderRequestsAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage =
            "Section - 17 Order Requests updated successfully";

          const index = state.OrderRequests.findIndex(
            (c) =>
              c.section17OrderRequests_ID ===
              action.payload.data.section17OrderRequests_ID,
          );

          if (index !== -1) {
            state.OrderRequests[index] = action.payload.data;
          }
        },
      )
      .addCase(updateSection17OrderRequestsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(deleteSection17OrderRequestsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        deleteSection17OrderRequestsAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage =
            "Section 17 Order Requests deleted successfully";

          state.OrderRequests = state.OrderRequests.filter(
            (c) => c.section17OrderRequests_ID !== action.payload,
          );
        },
      )
      .addCase(deleteSection17OrderRequestsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = sec17OrderRequestsSlice.actions;
export default sec17OrderRequestsSlice.reducer;
